import { useGetSurveysTotalCountQuery } from '@ocx/graphql';
import { SurveysTabBarIconWithBadge } from './SurveysTabBarIconWithBadge';

export const SurveysTabBarIconWithBadgeController = () => {
  const { data } = useGetSurveysTotalCountQuery();
  return <SurveysTabBarIconWithBadge totalCount={data?.surveys.totalCount || 0} />;
};
